export const columnsForType = {
  all: [
    'checkbox',
    'reference',
    'buyer',
    'taxStatus',
    'paymentStatus',
    'invoiceStatus',
    'logisticStatus',
    'moscowClassification',
    'expectedDeliveryAt',
    'items',
    'transportPrice',
    'totalQuantity',
    'totalPrice',
    'keyAccountManager',
    'tableActionsButtons',
  ],
  sale: [
    'checkbox',
    'reference',
    'buyer',
    'taxStatus',
    'paymentStatus',
    'invoiceStatus',
    'logisticStatus',
    'moscowClassification',
    'expectedDeliveryAt',
    'items',
    'transportPrice',
    'totalQuantity',
    'totalPrice',
    'keyAccountManager',
    'tableActionsButtons',
  ],
  profile: [
    'checkbox',
    'reference',
    'buyer',
    'taxStatus',
    'createdAtDistanceToNow',
    'items',
    'totalPrice',
    'totalQuantity',
    'moscowClassification',
    'keyAccountManager',
    'tableActionsButtons',
  ],
  finance: [
    'checkbox',
    'reference',
    'buyer',
    'paymentStatus',
    'invoiceStatus',
    'taxStatus',
    'totalPrice',
    'tableActionsButtons',
  ],
  logistic: [
    'checkbox',
    'reference',
    'buyer',
    'logisticStatus',
    'paymentStatus',
    'expectedDeliveryAt',
    'deliveryOption',
    'tableActionsButtons',
  ],
  credit: [
    'checkbox',
    'reference',
    'buyer',
    'creditOrderStatus',
    'paymentStatus',
    'totalPrice',
    'orderFinance',
    'deliveredAt',
    'paymentExpiresAt',
    'expectedDeliveryAt',
    'daysToExpire',
    'expectedPaymentDate',
    'tableActionsButtons',
  ],
}
